module.exports = __webpack_public_path__ + "img/ventas.ffc86a0e.png";